import { ApiErrorResponseBodyProps, ApiErrorTypes } from 'config/api'

const duplicatedArr: (arr1: string[], arr2: string[]) => boolean = (
  arr1,
  arr2
) => {
  return !!arr1.filter((n) => arr2.includes(n) && arr1.includes(n)).length
}

export type IsErrorProps = {
  type?: ApiErrorTypes
  key?: string | string[]
  value?: string | string[]
}

/**
 * サーバーから来たerrorMessageのbodyである
 * https://docs.google.com/spreadsheets/d/1nDcRQl8AB39GesZnmEzZiK5Q1Aie5hHXWQNPJG-FNcs/edit#gid=1607604007
 * のレスポンスBodyを判定する関数
 *
 * @param errorMessage // レスポンスBodyオブジェクト
 * @param type // レスポンスBodyのtype
 * @param key // レスポンスBody"values"のキー 複数条件の場合は配列で指定できる
 * @param value// レスポンスBody"values"のパラーメータの値の配列に含まれている文字列 複数条件の場合は配列で指定できる
 */
const isError: (
  errorMessage: ApiErrorResponseBodyProps,
  props: IsErrorProps
) => boolean = (errorMessage, { type, key, value }) => {
  let result: boolean = true
  const names: string[] = []
  if (errorMessage?.values) {
    Object.keys(errorMessage.values).map((key) => names.push(key))
  }

  if (type !== undefined && errorMessage?.type !== type) {
    result = false
  }

  if (key instanceof Array) {
    if (!duplicatedArr(key, names)) {
      result = false
    }
    const allKeys: string[] = []
    names.forEach((key) => {
      const arr = errorMessage?.values?.[key]
      arr && allKeys.push(...arr)
    })
    if (value instanceof Array) {
      if (!duplicatedArr(allKeys, value)) {
        result = false
      }
    } else {
      if (value !== undefined && !allKeys.includes(value)) {
        result = false
      }
    }
  } else {
    if (key !== undefined) {
      if (!names.includes(key)) {
        result = false
      }
      if (value instanceof Array) {
        const arr = errorMessage?.values?.[key] || []
        if (!duplicatedArr(arr, value)) {
          result = false
        }
      } else {
        if (
          value !== undefined &&
          !errorMessage?.values?.[key]?.includes?.(value)
        ) {
          result = false
        }
      }
    } else {
      // name未指定の時
      let arr: string[] = []
      Object.values(errorMessage.values).forEach((a) => {
        arr = [...arr, ...a]
      })
      if (value instanceof Array) {
        if (!duplicatedArr(arr, value)) {
          result = false
        }
      } else {
        if (value && !arr.includes(value)) {
          result = false
        }
      }
    }
  }

  return result
}

export default isError
